import { render, staticRenderFns } from "./CampanhaManage.vue?vue&type=template&id=1e3d3290&scoped=true"
import script from "./CampanhaManage.vue?vue&type=script&lang=js"
export * from "./CampanhaManage.vue?vue&type=script&lang=js"
import style0 from "./CampanhaManage.vue?vue&type=style&index=0&id=1e3d3290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3d3290",
  null
  
)

export default component.exports